import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ShuttlesService, TicketsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TRoutesViewModel, TTicket, TShuttle } from '@shared/models';

@Component({
    'selector': 'app-route1ShuttleSelection',
    'templateUrl': './route1ShuttleSelection.page.html',
    'styleUrls': ['./route1ShuttleSelection.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Route1ShuttleSelectionPage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: TRoutesViewModel;
    public errMsg = '';
    public idleShuttles: TShuttle[] = [];

    constructor(private shuttlesService: ShuttlesService, private ticketsService: TicketsService,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ROUTE_PAGE1);
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        this.initializeVm();
        this.loadNewRoute();
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.pushPopoverMenuItem('Show Tour', 'show-route-1-tour');
    // }

    private async loadNewRoute() {
        try {
            await this.uxHelperService.showSpinner();
            this.idleShuttles = await this.shuttlesService.getIdleShuttles();
            const tickets: TTicket[] = await this.ticketsService.getPendingTickets();

            if (this.idleShuttles.length === 0) {
                throw Error('No shuttles are currently idle.  Unable to create a new route for a shuttle.');
            }

            if (tickets.length === 0) {
                throw Error('No tickets are currently pending.  Unable to proceed with creating a route.');
            }
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.errMsg = errorMessage;
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    public hasError() {
        return this.errMsg;
    }

    public onNextClick() {
        if (!this.errMsg && this.vm.step1Complete) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/routes/route2TicketSelection');
        } else {
            this.uxHelperService.showAlert('Error', 'No shuttle has been selected.');
        }
    }

    public onShuttleClick(shuttle) {
        this.vm.selectedShuttle = shuttle;
        this.vm.dropoffManifest = {
            'seatsAvailable': this.vm.selectedShuttle.passengerCapacity,
            'selectedTickets': []
        };
        this.vm.pickupManifest = {
            'seatsAvailable': this.vm.selectedShuttle.passengerCapacity,
            'selectedTickets': []
        };

        // this.vm.pickupManifest.seatsAvailable = this.vm.selectedShuttle.passengerCapacity;
        this.vm.step1Complete = true;
    }

    private async initializeVm() {
        try {
            const dealership = this.sessionService.getDealership();
            const setting = await this.settingsService.get();

            this.vm = {
                'dropoffManifest': { 'selectedTickets': [], 'seatsAvailable': 0 },
                'pickupManifest': { 'selectedTickets': [], 'seatsAvailable': 0 },
                'selectedTickets': [],
                'sentStatuses': [],
                'selectedShuttle': null,
                'setting': setting,
                'routeLegs': [],
                'numDropoffPassengers': 0,
                'driverName': '',
                'sms': { 'allAboardRenderedMessage': '' },
                'sessionId': 0,

                'step1Complete': false,
                'step2Complete': false,
                'step3Complete': false,
                'step4Complete': false,
                'step5Complete': false,
                'step6Complete': false,
                'step7Complete': false,
                'dealership': dealership,

                'startingPoint': {
                    'atDealership': true,
                    'location': {
                        'address': dealership.address,
                        'locationName': dealership.dealershipName,
                    }
                },

                'endingPoint': {
                    'atDealership': true,
                    'location': {
                        'address': dealership.address,
                        'locationName': dealership.dealershipName,
                    }
                    // 'toAddress = this.vm.dealership.address;
                    // 'address1 = this.vm.dealership.address1;
                    // 'address2 = this.vm.dealership.address2;
                }
            }
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }
}
